// extracted by mini-css-extract-plugin
export default {"iconSuccess":"styles_iconSuccess__hZOI6"};